var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Pipe } from '@angular/core';
import { FilterByPipe } from './filter-by';
// tslint:disable use-pipe-transform-interface
var FilterByImpurePipe = (function (_super) {
    __extends(FilterByImpurePipe, _super);
    function FilterByImpurePipe() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FilterByImpurePipe.decorators = [
        { type: Pipe, args: [{ name: 'filterByImpure', pure: false },] },
    ];
    /** @nocollapse */
    FilterByImpurePipe.ctorParameters = function () { return []; };
    return FilterByImpurePipe;
}(FilterByPipe));
export { FilterByImpurePipe };
//# sourceMappingURL=filter-by-impure.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/array/filter-by-impure.js
// module id = 222
// module chunks = 4